import React from 'react';
import cn from 'classname';
import './index.less';

function Textarea({ className, input, meta, disabled }) {
	return (
		<div>
			<textarea
				className={cn('new-textarea--input', className)}
				{...input}
				disabled={disabled}
			/>
			{(meta.touched && meta.error) && (
				<div className='new-textarea--error'>{meta.error}</div>
			)}
		</div>
	);
}

export default Textarea;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/new-textarea/index.js